<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
    >
        <rect x="3" y="4" width="18" height="16" rx="2"/>
        <circle cx="8.5" cy="9" r="1.5"/>
        <path d="m4 17 4.5-4.5a2 2 0 0 1 2.8 0L14 15.2l1.2-1.2a2 2 0 0 1 2.8 0l3 3"/>
    </svg>
</template>
